<div  fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="width: 29vw;height: 28vh;">
    <h2>
        <mat-icon style="color:#00BA34;font-size: 50px;">check_circle</mat-icon>
    </h2>
    <!-- <h3>Congratulations!</h3> -->
    <div fxLayout="column" fxLayoutAlign="center center">
        <label class="approval-dialog">Are you sure you want to approve Business leagal name and address?</label>
        
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
        <button type="button" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
            style="padding:10px 70px;" (click)="closePopup()">No

        </button>
        <button type="button" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
            style="padding:10px 70px;background: #386AF6; color:#fff" (click)="verifyKyc('ACTIVE')" >Yes</button>
        

    </div>


</div>